import React, { useEffect, useState, useRef } from 'react'
import BottomFooter from '../BottomFooter'
import Loader from '../Loader'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { ADMIN_API } from '../../common/common';
import { postApiAdmin } from '../../service';
import { Logout } from '../../common/Funcation';
import moment from 'moment';
import { getTheme, styleObjectGetBG } from '../../common/StyleSeter';
import { relative } from 'path';



let dropdown = [
  { name: 'All', value: 'all' },
  { name: 'Unmatched', value: 'UnMatched' },
  { name: 'Matched', value: 'isMatched' },
]

const CATEGORY_TAB = [
  { name: 'All', value: 'all' },
  { name: 'Exchange', value: 'exchange' },
  { name: 'Casino', value: 'casinoBet' },
  { name: 'Fancybet', value: 'fancyBet' },
  { name: 'Bookmaker', value: 'bookMaker' },
  { name: 'Sportsbook', value: 'sportsBook' },
  { name: 'Binary', value: 'binary' },
  { name: 'Parlay', value: 'other' }
]




function CurrentBet(_props: any) {
  const [isLoadingMain, setIsLoadingMain] = useState(false)
  const [activeCategory, setActiveCategory] = useState('All')
  const [duringFilter, setDuringFilter] = useState('all')
  const [activeDD, setActiveDD] = useState(false)
  const [during, setDuring] = useState(false)
  const navigate = useNavigate();
  const HeaderData = useSelector((e: any) => e.Header);
  const userData = useSelector((e: any) => e.userData);
  const DD = useSelector((e: any) => e.domainDetails);
  const userId = HeaderData?._id
  const [pageData, setPageData] = useState<any>({})
  const [selectedDropdown, setSelectedDropdown] = useState('All')
  const [openBet, setOpenBet] = useState('')

  const tabsRef = useRef<(HTMLLIElement | null)[]>([]);
  const tabsContainerRef = useRef<HTMLDivElement | null>(null);

  const [sliderStyle, setSliderStyle] = useState({
    left: 0,
    width: 0,
  });


  // useEffect(() => {
  //   getPageData()
  //   return () => {
  //   }
  // }, [])

  useEffect(() => {
    getPageData();
  }, [activeCategory])

  // useEffect(() => {
  //   const tabIndex = activeCategory === 'all' ? 0 : activeCategory === 'exchange' ? 1 : activeCategory === 'casino' ? 2 : activeCategory === 'fancy' ? 3 : activeCategory === 'bookMark' ? 4 : activeCategory === 'sportsBook' ? 5 : activeCategory === 'binary' ? 6 : activeCategory === 'parlay' ? 7 : 8;
  //   const currentTab = tabsRef.current[tabIndex];
  //   if (currentTab) {
  //     setSliderStyle({
  //       left: currentTab.offsetLeft,
  //       width: currentTab.offsetWidth,
  //     });
  //   }
  // }, [activeCategory]);


  useEffect(() => {
    const activeTab = tabsRef.current.find(
      (tab) =>
        tab?.textContent?.trim() === activeCategory
    );

    const tabsContainer = tabsContainerRef.current;

    if (!activeTab || !tabsContainer) return;

    const tabRect = activeTab.getBoundingClientRect();
    const containerRect = tabsContainer.getBoundingClientRect();

    setSliderStyle({
      left: tabRect.left - containerRect.left + tabsContainer.scrollLeft,
      width: tabRect.width,
    });

    const tabLeft = activeTab.offsetLeft;
    const tabRight = tabLeft + activeTab.offsetWidth;

    const visibleLeft = tabsContainer.scrollLeft;
    const visibleRight =
      visibleLeft + tabsContainer.clientWidth;

    if (tabLeft < visibleLeft) {
      tabsContainer.scrollTo({
        left: tabLeft - 10,
        behavior: 'smooth',
      });
    } else if (tabRight > visibleRight) {
      tabsContainer.scrollTo({
        left: tabRight - tabsContainer.clientWidth + 10,
        behavior: 'smooth',
      });
    }
  }, [activeCategory]);

  const getPageData = async () => {
    setIsLoadingMain(true)
    let data: any = {
      api: ADMIN_API.PLAYER_CURRENT_BETS,
      value: {
        id: userId ? userId : userData?._id,
        bet: 'active',
        betStatus: 'all',
        betType: CATEGORY_TAB.find((item) => item.name === activeCategory)?.value || 'all',
        // filter: dropdown.find((_: any) => _.name === selectedDropdown)?.value
        filter: "all"
      },
    }


    await postApiAdmin(data).then(function (response) {
      // console.log("pageData::: ", response);
      setPageData(response.data.data)
      // setIsLoadingMain(false)
    }).catch(err => {
      if (err.response.data.statusCode === 401) {
        // setIsLoadingMain(false)
        Logout()
        navigate('/login')
      }
    }).finally(() => {
      setIsLoadingMain(false)
    })
  }



  const handleDDselect = (value: any) => {
    setSelectedDropdown(value)
    setActiveDD(false)
  }

  const handleOpenBetAccordian = (value: any) => {
    if (value === openBet) {
      setOpenBet('')
    }
    else {
      setOpenBet(value)
    }
  }


  return (
    <>
      <div className='full-wrap bottomfooter leagues'>
        {isLoadingMain &&
          <div className='loader_top'>
            <Loader />
          </div>
        }

        <style>{`
                    .paddingZero {
                    padding-left: 0px !important;
                    }
                    .sports-tab-panel {
                          position: relative;
                      }

                      .sports-tab-scroll {
                          position: relative;
                          width: 100%;
                          overflow-x: auto;
                          overflow-y: hidden;
                          -webkit-overflow-scrolling: touch;
                          scrollbar-width: none;
                      }

                      .sports-tab-scroll::-webkit-scrollbar {
                          display: none;
                      }

                      .sports-tab-list {
                          position: relative;
                          display: inline-flex;
                          align-items: center;
                          flex-wrap: nowrap;
                          list-style: none;
                          width: max-content;
                          min-width: 100%;
                          margin: 0;
                          padding: 0 0 6px 0;
                          box-sizing: border-box;
                      }

                      .sports-tab-panel-item {
                          position: relative;
                          flex: 0 0 auto;
                          cursor: pointer;
                          margin: 0 8px;
                          white-space: nowrap;
                      }

                      .sports-tab-panel-item h3 {
                          margin: 0;
                          padding: 0;
                          font-weight: 700;
                          font-size: 13.52px;
                      }

                      .sports-tab-panel-item.selected h3 {
                          font-weight: 700;
                      }

                      .sports-tab-panel-item.not-selected h3 {
                          font-weight: 700;
                      }

                      .tab-slider {
                          position: absolute;
                          bottom: 0px;
                          height: 4px;
                          background-color: black;
                          border-radius: 10px;

                          transition:
                              left 0.3s ease,
                              width 0.3s ease;

                          pointer-events: none;
                      }
                    .sports-tab-panel-item h3 {
                        margin: 0;
                        padding: 0;
                    }
                    .sports-tab-panel-item.selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .sports-tab-panel-item.not-selected h3 {
                        font-weight: 700;
                        font-size: 13.52px;
                    }
                    .tab-slider {
                        transition: left 0.3s ease, width 0.3s ease !important;
                        margin: 0;
                        padding: 0;
                    }
                `}</style>
        <div className="paddingZero balance-label position-relative" style={{ fontSize: "14.56px", fontWeight: 400 }}>
          {/* <button className="bg-transparent border-0 text-white position-absolute start-0 pt-0" onClick={() => navigate('/')}>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 512" className="fs-3" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path>
            </svg>
          </button> */}
          Current Bets
          <div className='cross-icon' onClick={() => navigate('/')} />
        </div>

        <div className="pt-0 inner-sidebar-content" style={{ minHeight: "100vh" }}>
          <div
            className="sports-tab-panel position-relative"
            style={{
              paddingLeft: "0.5rem",
              paddingRight: 0,
              paddingBottom: "0.3rem",
              paddingTop: "0.6rem",
            }}
          >
            <div
              ref={tabsContainerRef}
              className="sports-tab-scroll"
            >
              <ul className="sports-tab-list">
                <li
                  ref={(el) => (tabsRef.current[0] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'All'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('All')}
                >
                  <h3>All</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[1] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Exchange'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Exchange')}
                >
                  <h3>Exchange</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[2] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Casino'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Casino')}
                >
                  <h3>Casino</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[3] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Fancybet'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Fancybet')}
                >
                  <h3>Fancybet</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[4] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Bookmaker'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Bookmaker')}
                >
                  <h3>Bookmaker</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[5] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Sportsbook'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Sportsbook')}
                >
                  <h3>Sportsbook</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[6] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Binary'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Binary')}
                >
                  <h3>Binary</h3>
                </li>

                <li
                  ref={(el) => (tabsRef.current[7] = el)}
                  className={`sports-tab-panel-item ${activeCategory === 'Parlay'
                    ? 'selected'
                    : 'not-selected'
                    }`}
                  onClick={() => setActiveCategory('Parlay')}
                >
                  <h3>Parlay</h3>
                </li>

                <div
                  className="tab-slider"
                  style={{
                    left: `${sliderStyle.left}px`,
                    width: `${sliderStyle.width}px`,
                  }}
                />
              </ul>
            </div>
          </div>

          <div className="pl-filter">
            <div className="select-container bet-history-dropdown" style={{ paddingBottom: 0 }}>
              <div className="dropdown" style={{ marginBottom: "0.5rem" }}>
                <button type="button" onClick={() => setActiveDD(!activeDD)} id="dropdown-basic-button" aria-expanded="false"
                  className={`${activeDD ? 'show' : ''} dropdown-toggle btn btn-primary`} style={{ justifyContent: "start", fontWeight: 700 }}>
                  <span style={{ paddingRight: "8px", fontWeight: 400 }}>Bet Status</span> {selectedDropdown}
                </button>

                <div x-placement="bottom-start" aria-labelledby="dropdown-basic-button" className={`${activeDD ? 'show' : ''} dropdown-menu`} data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom-start" style={{ paddingLeft: "87px", paddingRight: "1rem" }}
                >

                  {dropdown.filter((_) => _.name !== selectedDropdown).map((item, i) => {
                    return (
                      <>
                        <a key={i} className="dropdown-item" style={{ padding: 0, height: "31px", fontWeight: 700 }} onClick={() => handleDDselect(item.name)}> {item.name}</a> </>
                    )
                  })}
                </div>
              </div>
              <div>
                <form>
                  <div className="d-flex align-items-center justify-content-end order-checkbox">
                    <label className="text-yellow pb-0 mb-0 form-label" style={{ marginRight: "0.5rem" }} >Order By</label>
                    <div className="text-white d-flex form-check">
                      <input type="checkbox" id="default-checkbox" className="form-check-input" />
                      <label title="" htmlFor="default-checkbox" className="form-check-label">Bet Placed</label>
                    </div>
                    <div className="text-white d-flex form-check">
                      <input type="checkbox" id="disabled-default-checkbox" className="form-check-input" />
                      <label title="" htmlFor="disabled-default-checkbox" className="form-check-label">Market</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="p-3">
            {pageData && pageData?.bets?.length > 0 ? pageData.bets.map((item: any, i: any) => {
              return (
                <div key={i} className="all-bets position-relative">
                  <div className={`current-bets-table mt-3  ${openBet === i ? 'show' : ''}`}>
                    <table className="overflow-hidden bg-white mb-0 odds-table table table-bordered">
                      <thead>
                        <tr>
                          <th colSpan={4} style={{ fontSize: "13.52px", textTransform: "capitalize", textAlign: "center" }}>
                            {item.type}
                            <svg stroke="#5a5e62" fill="#5a5e62" strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                            </svg>
                            <span className="master-pass" style={{ paddingLeft: 0 }}>{item.name}</span>
                            <svg stroke="#5a5e62" fill="#5a5e62" strokeWidth="0" viewBox="0 0 24 24" className="arrow-icon" style={{ margin: "0px 3px" }} height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"></path>
                            </svg>
                            <span className="master-pass" style={{ fontWeight: 400, paddingLeft: 0 }}>{item.betType}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* <tr className="lay-back">
                          <td colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'} `}>{item.betSide} </span> {item.selection}</td>
                        </tr> */}
                        <tr>
                          <td style={{ padding: ".5rem", borderRightWidth: 0 }}>
                            <div style={{
                              background: "#d4e0e5",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "99999px",
                              width: "52px",
                              height: "30px"
                            }}>
                              <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                              <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                              <div style={{ width: "4.16px", height: "4.16px", background: "#6f8898", marginRight: "0.25rem", borderRadius: "99999px" }}></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <style>
                            {`
                              td.table-data-header {
                                font-size: 10.4px !important;
                              }
                            `}
                          </style>
                          <td className='table-data-header'>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp.toFixed(2)}</strong></td>
                          <td className='table-data-header'>Stake (PBU) <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake.toFixed(2)}</strong></td>
                          <td className='table-data-header'>Profit (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.profit?.toFixed(2)}</strong></td>
                        </tr>
                        <tr>
                          <style>
                            {`
                              td.table-data-bet-id {
                                font-size: 12.48px !important;
                                padding: 0.25rem 0.5rem  !important;
                              }
                            `}
                          </style>
                          <td className='table-data-bet-id'>Bet ID</td>
                          <td className='table-data-bet-id' colSpan={2}>{item._id}</td>
                        </tr>
                        <tr>
                          <style>
                            {`
                              td.table-data-bet-placed {
                                font-size: 12.48px !important;
                                padding: 0.25rem 0.5rem  !important;
                              }
                            `}
                          </style>
                          <td className='table-data-bet-placed'>Bet Placed</td>
                          <td className='table-data-bet-placed' colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</td>
                        </tr>
                        {(item?.profit !== null || "") ? (
                          <tr>
                            <style>
                              {`
                              td.table-data-profit {
                                font-size: 12.48px !important;
                                padding: 0.25rem 0.5rem !important;
                              }
                            `}
                            </style>
                            <td className='table-data-profit'>Profit/Loss (PBU)</td>
                            <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.profit?.toFixed(2)}</td>
                          </tr>
                        ) : ""}
                      </tbody>
                    </table>

                    {openBet === i &&
                      <table className="bets-table mb-0 table" style={{ background: "#e2eaef" }}>
                        <thead>
                          <th style={{ fontSize: "12.48px", fontWeight: 400, padding: "6px 11px" }} className="pe-0">Bet Taken</th>
                          <th style={{ fontSize: "12.48px", fontWeight: 400, padding: "6px 11px" }} colSpan={2}>{moment(item.createdAt).format('DD-MM-YYYY hh:mm:ss')}</th>
                        </thead>
                        <tbody>
                          <tr className="lay-back">
                            <td style={{ fontSize: "12.48px", fontWeight: 700, padding: "6px 11px", textTransform: "capitalize" }} colSpan={3}> <span className={`bet-name ${item.betSide === 'back' ? 'back' : 'lay'}`} style={{ fontSize: "13.52px", fontWeight: 700, lineHeight: 2, padding: "6px 10px" }}>{item.betSide} </span> {item.selection}</td>
                          </tr>
                          <tr>
                            <style>
                              {`
                              td.table-data-header {
                                font-size: 10.4px !important;
                              }
                            `}
                            </style>
                            <td className='table-data-header' style={{ borderRightWidth: "1px", borderRightColor: "#dee2e6" }}>Odds req. <strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp.toFixed(2)}</strong></td>
                            <td className='table-data-header' style={{ borderRightWidth: "1px", borderRightColor: "#dee2e6" }}>Odds Matched<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.oddsUp.toFixed(2)}</strong></td>
                            <td className='table-data-header'>Stake (PBU)<strong className="d-block" style={{ fontSize: "14.56px", fontWeight: 700, lineHeight: 1.2 }}>{item.stake?.toFixed(2)}</strong></td>
                          </tr>
                          <tr>
                            <style>
                              {`
                              td.table-data-bet-placed {
                                font-size: 12.48px !important;
                                padding: 0.25rem 0.5rem  !important;
                              }
                            `}
                            </style>
                            <td className='table-data-bet-placed'>Liability (PBU)</td>
                            <td className='table-data-profit text-success' style={{ color: "green" }} colSpan={2}>{item.stake?.toFixed(2)}</td>
                          </tr>

                        </tbody>
                      </table>
                    }

                  </div>
                  <button className={`show-hide-bet  ${openBet === i ? 'arrow-up' : ''}`} style={{ padding: "0px 38px", borderRadius: "0 0 7.5px 7.5px" }} onClick={() => handleOpenBetAccordian(i)}>
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" height="1rem" width="1rem" xmlns="http://www.w3.org/2000/svg">
                      <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"></path>
                    </svg>
                  </button>
                </div>

              )
            }) :

              <div className="no-event-outer">
                <div className="no-event">
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="lightgrey" className="mb-2" height="55" width="55" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                  </svg>
                  No Event
                </div>
              </div>

            }


          </div>

        </div>






      </div>
      {/* <BottomFooter /> */}



      {during && <div className="market-depth-modal">
        <div className="market-title">
          <h4 style={{ fontSize: "14.5749px" }}>During</h4>
          <button type="button" onClick={() => setDuring(false)} className="border-0 abc text-white position-absolute end-0 top-0 pt-1 fs-4 bg-transparent border-0 btn btn-primary">
            <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.80702 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
        <div className="d-flex justify-content-center align-items-center w-100" style={{ padding: "0 0.5rem 0.5rem 0.5rem", background: "#000" }}>
          <div className="p-2 calendar-button" style={{ background: "#fff", borderRadius: "0.5rem", gap: "0.5rem" }}>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { setDuringFilter('today'); }}>Today</button>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { setDuringFilter('yesterday'); }}>From Yesterday</button>
            <button type="button" className="btn btn-primary" style={{ fontSize: "12.5px", width: "100%" }} onClick={() => { setDuringFilter('last7days'); }}>Last 7 Days</button>
          </div>
        </div>
      </div>}
    </>



  )
}

export default CurrentBet